/* ───────────── Saint Croix · tema de Shopify ─────────────
   Animaciones y comportamiento de la tienda: cabecera con logo flotante,
   cortina entre páginas, menú, buscador, bolsa (API AJAX de Shopify),
   filtros, ficha de producto, favoritos y ventana de bienvenida. */
(() => {
'use strict';

const SC = window.SC || {};
const T = SC.t || {};
const R = SC.routes || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const root = document.documentElement;
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
const DESIGN = !!SC.design || !!(window.Shopify && window.Shopify.designMode);
const app = $('#MainContent') || document.body;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const LANG = root.lang || 'es';

const store = {
  get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
};
const ss = {
  get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  del(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
};
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sleep = ms => new Promise(r => setTimeout(r, ms));
const parseHTML = html => new DOMParser().parseFromString(html, 'text/html');
const B = label => `<span class="t"><span data-t="${esc(label)}">${esc(label)}</span></span>`;
function setCls(el, c, on) { if (el && el.classList.contains(c) !== on) el.classList.toggle(c, on); }
function plural(n, one, other) { return (n === 1 ? one : other).replace('{n}', n); }

/* ───── dinero ───── */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const ph = /\{\{\s*(\w+)\s*\}\}/;
  const fmt = format || '{{amount_with_comma_separator}} €';
  const delim = (n, p, th = ',', dc = '.') => {
    if (n == null || isNaN(n)) return '0';
    const parts = (n / 100).toFixed(p).split('.');
    return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dc + parts[1] : '');
  };
  const m = fmt.match(ph); let v;
  switch (m && m[1]) {
    case 'amount_no_decimals': v = delim(cents, 0); break;
    case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
    case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' ', ''); break;
    case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
    case 'amount_with_period_and_space_separator': v = delim(cents, 2, ' ', '.'); break;
    default: v = delim(cents, 2);
  }
  return fmt.replace(ph, v).replace(/<[^>]*>/g, '');
}
const money = c => formatMoney(c, SC.moneyFormat);

/* ───── peticiones ───── */
async function postJSON(url, body) {
  const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
  let j = {}; try { j = await r.json(); } catch (e) {}
  if (!r.ok) { const err = new Error(j.description || j.message || T.error || 'Error'); err.data = j; err.status = r.status; throw err; }
  return j;
}
async function getText(url, signal) {
  const r = await fetch(url, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
  if (!r.ok) throw new Error(r.status);
  return r.text();
}
function withParam(url, k, v) { const u = new URL(url, location.href); u.searchParams.set(k, v); return u.pathname + u.search; }

/* ───── capas: menú, buscador, bolsa, filtros, guía de tallas, visor ───── */
const stack = [];
const isOpen = id => stack.includes(id);
function lock(on) {
  if (on) { root.style.setProperty('--sbw', Math.max(0, innerWidth - root.clientWidth) + 'px'); root.classList.add('lock'); if (lenis) lenis.stop(); }
  else { root.classList.remove('lock'); root.style.setProperty('--sbw', '0px'); if (lenis) lenis.start(); }
}
function openOv(id, arg) {
  const el = document.getElementById(id); if (!el) return false;
  if (id === 'menu') { el.classList.add('was-open'); }
  if (id === 'sizes') fillGuide(arg);
  if (isOpen(id)) return true;
  if (id !== 'menu' && isOpen('menu')) closeOv('menu');
  if (id === 'search' && isOpen('bag')) closeOv('bag');
  el._ret = document.activeElement;
  el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
  stack.push(id);
  if (id === 'menu') { const b = $('#menuBtn'); if (b) b.setAttribute('aria-expanded', 'true'); }
  lock(true);
  setTimeout(() => {
    const f = el.querySelector('[data-autofocus]:not([hidden])') || (FINE ? el.querySelector('.x-btn') : null);
    if (f && isOpen(id) && f.offsetParent !== null) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }, 450);
  return true;
}
function closeOv(id) {
  if (!id) id = stack[stack.length - 1];
  const i = stack.indexOf(id); if (i < 0) return;
  const el = document.getElementById(id);
  stack.splice(i, 1);
  if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
  if (id === 'menu') {
    const b = $('#menuBtn'); if (b) b.setAttribute('aria-expanded', 'false');
    $$('.msub.is-open').forEach(s => { s.classList.remove('is-open'); s.previousElementSibling.setAttribute('aria-expanded', 'false'); });
    const mm = $('#menuMain'); if (mm) mm.classList.remove('has-open');
  }
  if (id === 'lightbox') lbZoom(false);
  if (id === 'news') store.set('sc_news_t', Date.now());
  if (!stack.length) lock(false);
  const r = el && el._ret;
  if (r && r.focus && document.contains(r) && FINE) { try { r.focus({ preventScroll: true }); } catch (e) {} }
}
function closeAll() { while (stack.length) closeOv(stack[stack.length - 1]); }

/* ───── desplazamiento suave ───── */
let lenis = null;
function initLenis() {
  if (RM || !FINE || DESIGN || !(SC.anim && SC.anim.smooth) || typeof window.Lenis === 'undefined') return;
  try {
    lenis = new window.Lenis({ lerp: 0.075, wheelMultiplier: 0.9, smoothWheel: true });
    const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    lenis.on('scroll', () => tick());
  } catch (e) { lenis = null; }
}
function scrollToEl(el, off = -120) {
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: off, duration: 1.6 });
  else window.scrollTo({ top: el.getBoundingClientRect().top + scrollY + off, behavior: RM ? 'auto' : 'smooth' });
}

/* ───── cabecera: barra que se esconde y logo flotante que se encoge ───── */
let topEl = null, brandF = null, hdrEl = null;
let heroEnd = -1, HDR = 0, stickV = '', ticking = false, LSY = 0;
const SCROLLERS = new Set();
const TOP_Y = 24;
function refreshHeader() { topEl = $('#top'); brandF = $('#brandF'); hdrEl = $('#hdr'); HDR = 0; LSY = 0; }
const hdrH = () => HDR || (HDR = hdrEl ? hdrEl.offsetHeight : 74);
function tick() {
  if (ticking) return; ticking = true;
  requestAnimationFrame(() => { ticking = false; frame(); });
}
function placeLogo() {
  if (!topEl) return 30;
  const ann = $('.ann', topEl), safe = parseFloat(getComputedStyle(topEl).paddingTop) || 0;
  const ly = safe + (ann ? ann.offsetHeight : 0) + hdrH() / 2;
  const sy = safe + (innerWidth <= 900 ? 22 : 30);
  root.style.setProperty('--ly', ly.toFixed(1) + 'px');
  root.style.setProperty('--lsy', sy.toFixed(1) + 'px');
  return sy;
}
function frame() {
  const y = window.scrollY;
  if (topEl) {
    if (!LSY) LSY = placeLogo();
    const atTop = y < TOP_Y;
    setCls(topEl, 'is-scrolled', !atTop);
    setCls(topEl, 'is-solid', heroEnd < 0 || y > heroEnd);
    if (!stack.length) { setCls(topEl, 'is-hidden', !atTop); setCls(brandF, 'is-small', !atTop); }
    const overHero = heroEnd >= 0 && y < heroEnd + hdrH() - LSY;
    setCls(brandF, 'on-dark', topEl.classList.contains('on-dark') && (atTop ? !topEl.classList.contains('is-solid') : overHero));
    const sv = topEl.classList.contains('is-hidden') ? Math.round(LSY * 2) + 'px' : hdrH() + 'px';
    if (sv !== stickV) { stickV = sv; root.style.setProperty('--stick', sv); }
  }
  SCROLLERS.forEach(f => f(y));
}
function measureHero() {
  const first = app.firstElementChild;
  const h = first ? first.querySelector('[data-hero]') : null;
  const transparent = !topEl || topEl.dataset.transparent !== 'false';
  root.classList.toggle('hero-first', !!h);
  heroEnd = h && transparent ? h.offsetHeight - (topEl ? topEl.offsetHeight : 0) - 10 : -1;
  if (topEl) topEl.classList.toggle('on-dark', !!h && transparent);
  tick();
}
let annTimer = null;
function initAnn() {
  clearInterval(annTimer);
  const msgs = $$('.ann-msg'); let i = 0;
  if (RM || msgs.length < 2) return;
  const ms = (topEl && +topEl.dataset.interval) || 4600;
  annTimer = setInterval(() => {
    const a = msgs[i]; i = (i + 1) % msgs.length; const b = msgs[i];
    a.classList.remove('is-on'); a.classList.add('is-off');
    b.classList.remove('is-off'); b.classList.add('is-on');
    setTimeout(() => a.classList.remove('is-off'), 1000);
  }, ms);
}

/* ───── pulsación, cursor y paralaje ───── */
function initRipple() {
  document.addEventListener('pointerdown', e => {
    if (RM) return;
    const b = e.target.closest('.btn, .icon-btn, .size, .q-s button, .q-one, .chip, .qty button, .code');
    if (!b || b.disabled) return;
    const r = b.getBoundingClientRect(); const s = Math.max(r.width, r.height) * 2.4;
    const sp = document.createElement('span'); sp.className = 'rp';
    sp.style.cssText = `left:${e.clientX - r.left}px;top:${e.clientY - r.top}px;width:${s}px;height:${s}px`;
    b.appendChild(sp); setTimeout(() => sp.remove(), 950);
  }, { passive: true });
}
function initCursor() {
  const c = $('#cursor');
  if (!c || !FINE || RM) return;
  root.classList.add('has-cursor');
  const ring = $('.c-ring', c), dot = $('.c-dot', c), lbl = $('#cursorT');
  let x = -100, y = -100, rx = -100, ry = -100, down = false, run = false;
  addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse') return;
    x = e.clientX; y = e.clientY; c.classList.remove('is-hidden');
    const t = e.target.closest ? e.target.closest('[data-cursor]') : null;
    const l = e.target.closest ? e.target.closest('a, button, [role="button"], input, select, label, textarea, .g-im, summary') : null;
    if (t) { if (lbl.textContent !== t.dataset.cursor) lbl.textContent = t.dataset.cursor; c.classList.add('is-label'); c.classList.remove('is-link'); }
    else { c.classList.remove('is-label'); c.classList.toggle('is-link', !!l); }
  }, { passive: true });
  document.addEventListener('pointerleave', () => c.classList.add('is-hidden'));
  addEventListener('pointerdown', () => { down = true; }, { passive: true });
  addEventListener('pointerup', () => { down = false; }, { passive: true });
  const loop = () => {
    rx += (x - rx) * 0.15; ry += (y - ry) * 0.15;
    dot.style.transform = `translate3d(${x}px,${y}px,0)`;
    ring.style.transform = `translate3d(${rx.toFixed(1)}px,${ry.toFixed(1)}px,0) scale(${down ? 0.82 : 1})`;
    if (Math.abs(x - rx) + Math.abs(y - ry) > 0.3) requestAnimationFrame(loop); else run = false;
  };
  const wake = () => { if (!run) { run = true; requestAnimationFrame(loop); } };
  addEventListener('pointermove', wake, { passive: true });
  addEventListener('pointerdown', wake, { passive: true });
  addEventListener('pointerup', wake, { passive: true });
}
let parEls = [];
function initParallax() {
  if (RM) return;
  SCROLLERS.add(() => {
    if (!parEls.length) return;
    const vh = innerHeight, out = [];
    for (const el of parEls) {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      out.push([el, ((r.top + r.height / 2 - vh / 2) / vh * -70).toFixed(1)]);
    }
    for (const [el, v] of out) if (el._py !== v) { el._py = v; el.style.transform = `translate3d(0,${v}px,0)`; }
  });
}

/* ───── entrada con el logo y cortina entre páginas ───── */
let readyResolve; const READY = new Promise(r => { readyResolve = r; });
async function runIntro() {
  const el = $('#intro'); if (!el) return;
  el.style.animation = 'none';
  if (RM || ss.get('sc_intro')) { el.remove(); return; }
  ss.set('sc_intro', '1');
  let skip = false; el.addEventListener('click', () => { skip = true; });
  await sleep(60); el.classList.add('is-run');
  const t0 = performance.now();
  while (!skip && performance.now() - t0 < 2100) await sleep(40);
  el.classList.add('is-out');
  await sleep(450);
  setTimeout(() => el.remove(), 1200);
}
const Veil = {
  el: () => $('#veil'),
  set(label, logo) {
    const t = $('#veilT'), l = $('#veilL');
    if (l) l.hidden = !logo;
    if (t) t.textContent = logo ? '' : (label || '');
  },
  async cover(label, logo) {
    const el = this.el(); if (!el) return;
    this.set(label, logo);
    el.getAnimations().forEach(a => a.cancel());
    el.classList.add('is-on');
    const line = $('.veil-line i', el);
    line.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: 900, easing: 'cubic-bezier(.7,0,.2,1)', fill: 'forwards' });
    $('.veil-in', el).animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 700, delay: 120, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
    await el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).finished;
  },
  async revealOnLoad() {
    const el = this.el();
    ss.del('sc_veil');
    if (!el || !root.classList.contains('veil-pre')) { root.classList.remove('veil-pre'); return; }
    el.classList.add('is-on');
    el.style.opacity = '1';
    root.classList.remove('veil-pre');
    const line = $('.veil-line i', el);
    line.animate([{ transform: 'scaleX(.35)' }, { transform: 'scaleX(1)' }], { duration: 650, easing: 'cubic-bezier(.7,0,.2,1)', fill: 'forwards' });
    try { await Promise.race([document.fonts ? document.fonts.ready : null, sleep(500)]); } catch (e) {}
    await sleep(320);
    await el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 700, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).finished;
    el.classList.remove('is-on'); el.style.opacity = '';
    el.getAnimations().forEach(a => a.cancel());
    $$('*', el).forEach(n => n.getAnimations().forEach(a => a.cancel()));
  },
  hide() { const el = this.el(); if (!el) return; el.getAnimations().forEach(a => a.cancel()); el.classList.remove('is-on'); el.style.opacity = ''; root.classList.remove('veil-pre'); }
};
let leaving = false;
function veilLink(a, e) {
  if (!SC.anim || !SC.anim.veil || RM || DESIGN || leaving) return false;
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
  if ((a.target && a.target !== '_self') || a.hasAttribute('download') || a.closest('[data-no-veil]')) return false;
  if (a.hasAttribute('data-open') || a.hasAttribute('data-facet-link') || a.hasAttribute('data-more') || a.hasAttribute('data-scroll')) return false;
  const href = a.getAttribute('href') || '';
  if (!href || href[0] === '#' || /^(mailto|tel|javascript|sms):/i.test(href)) return false;
  let u; try { u = new URL(a.href, location.href); } catch (err) { return false; }
  if (u.origin !== location.origin) return false;
  if (u.pathname === location.pathname && u.search === location.search) return false;
  if (/\/(checkouts?|account\/logout|cart\/(add|change|clear|update)|apps\/|tools\/)/.test(u.pathname)) return false;
  return u;
}
function navigate(u, label, logo) {
  leaving = true;
  ss.set('sc_veil', JSON.stringify({ t: label || '', logo: !!logo }));
  closeAll();
  Veil.cover(label, logo).then(() => { location.href = u.href; });
  setTimeout(() => { leaving = false; }, 5000);
}
addEventListener('pageshow', e => { if (e.persisted) { leaving = false; ss.del('sc_veil'); Veil.hide(); closeAll(); } });

/* ───── revelados al hacer scroll ───── */
let io = null;
function observe(scope) {
  const els = $$('[data-reveal]:not(.in)', scope);
  if (RM || DESIGN || !('IntersectionObserver' in window) || !root.classList.contains('js')) { els.forEach(e => e.classList.add('in')); return; }
  if (!io) io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -7% 0px', threshold: 0.05 });
  els.forEach(e => io.observe(e));
}
function splitAll(scope) {
  $$('[data-split]', scope).forEach(el => {
    if (el.dataset.done) return; el.dataset.done = '1';
    const txt = el.textContent.trim().replace(/\s+/g, ' ');
    if (!txt) return;
    el.setAttribute('aria-label', txt);
    el.innerHTML = txt.split(' ').map((w, i) => `<span class="w" aria-hidden="true"><span class="wi" style="--i:${i}">${esc(w)}</span></span>`).join(' ');
  });
}
let isReady = false;
function revealScope(scope) { splitAll(scope); if (isReady) observe(scope); }

/* ───── portada ───── */
function bindHero(hero) {
  if (!hero || hero._b) return; hero._b = true;
  const imgs = $$('.hero-ph img', hero).filter(im => im.offsetParent !== null || getComputedStyle(im.parentElement).display !== 'none');
  let n = 0, loaded = !imgs.length;
  const show = () => READY.then(() => requestAnimationFrame(() => hero.classList.add('is-in')));
  const done = () => { if (++n >= imgs.length && !loaded) { loaded = true; show(); } };
  imgs.forEach(im => (im.complete ? done() : (im.addEventListener('load', done, { once: true }), im.addEventListener('error', done, { once: true }))));
  if (loaded) show();
  setTimeout(show, 1600);
  if (RM) return;
  const copy = $('.hero-in', hero); const H = () => hero.offsetHeight;
  let last = -1;
  const all = $$('.hero-ph img', hero);
  const onY = y => {
    if (!document.contains(hero)) { SCROLLERS.delete(onY); return; }
    const h = H(); const top = hero.offsetTop;
    const yy = Math.max(0, Math.min(y - top, h + 40)); if (yy === last) return; last = yy;
    copy.style.transform = `translate3d(0,${(yy * 0.22).toFixed(1)}px,0)`;
    copy.style.opacity = String(Math.max(0, 1 - (yy / h) * 1.5).toFixed(3));
    all.forEach((im, i) => { im.style.translate = `0 ${(yy * (i ? 0.16 : 0.1)).toFixed(1)}px`; });
  };
  SCROLLERS.add(onY);
}

/* ───── avisos (barra oscura abajo) ───── */
function toast(html, o = {}) {
  const wrap = $('#toasts'); if (!wrap) return;
  const el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status');
  el.innerHTML = `<div class="t-tx">${html}</div>` + (o.action ? `<button class="u" type="button">${esc(o.action.label)}</button>` : '<span></span>');
  let gone = false;
  const dismiss = () => { if (gone) return; gone = true; el.classList.add('is-out'); setTimeout(() => el.remove(), 500); };
  if (o.action) $('.u', el).addEventListener('click', () => { dismiss(); o.action.run(); });
  [...wrap.children].forEach(x => { x.classList.add('is-out'); setTimeout(() => x.remove(), 500); });
  wrap.appendChild(el);
  setTimeout(dismiss, o.ms || 4000);
}
const viewBag = () => ({ label: T.viewBag || 'Ver la bolsa', run: () => { if (!openOv('bag')) location.href = R.cart; } });

/* ───── favoritos (en el navegador, sin cuenta) ───── */
const W = { list: store.get('sc_wish', []).filter(x => typeof x === 'string') };
function wishStates(scope = document) {
  $$('[data-wish]', scope).forEach(b => { const on = W.list.includes(b.dataset.wish); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', on ? (T.wishRemove || '') : (T.wishAdd || '')); });
  $$('[data-wish-count]').forEach(e => { e.textContent = W.list.length ? `(${W.list.length})` : ''; });
}
function toggleWish(handle, btn) {
  const i = W.list.indexOf(handle), on = i < 0;
  if (on) W.list.unshift(handle); else W.list.splice(i, 1);
  store.set('sc_wish', W.list); wishStates();
  if (on && btn) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
  const card = btn && btn.closest('.card');
  const name = (card && $('.card-name', card) && $('.card-name', card).textContent) || ($('.pdp-name') && $('.pdp-name').textContent) || '';
  toast(`<b>${esc(on ? T.wishAdded : T.wishRemoved)}</b>${esc(name)}`, { action: on ? { label: T.view || 'Ver', run: () => { location.href = R.wishlist; } } : null });
  const page = $('[data-wish-page]');
  if (!on && page && card) {
    const done = () => { card.remove(); wishPageState(page); };
    if (RM) done(); else card.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.97)' }], { duration: 500, easing: 'ease', fill: 'forwards' }).finished.then(done);
  }
}
function wishPageState(page) {
  const n = $$('.card', page).length, sub = $('[data-wish-sub]', page);
  $('[data-wish-empty]', page).hidden = n > 0;
  if (sub && n) sub.textContent = plural(n, page.dataset.one, page.dataset.other);
}
async function initWishPage(scope) {
  const page = $('[data-wish-page]', scope); if (!page || page._b) return; page._b = true;
  const grid = $('[data-wish-grid]', page);
  if (!W.list.length) { wishPageState(page); return; }
  const base = (R.root || '/').replace(/\/$/, '');
  const htmls = await Promise.all(W.list.map(h => getText(`${base}/products/${encodeURIComponent(h)}?section_id=sc-card`).catch(() => '')));
  const keep = [];
  grid.innerHTML = htmls.map((h, i) => {
    const d = parseHTML(h); const c = $('.card', d);
    if (!c) return ''; keep.push(W.list[i]);
    c.style.setProperty('--i', i % 12); return c.outerHTML;
  }).join('');
  if (keep.length !== W.list.length) { W.list = keep; store.set('sc_wish', keep); }
  grid.style.setProperty('--cols', innerWidth > 640 ? 3 : 2);
  $$('.card', grid).forEach(c => { c.style.animation = `cardIn 1.1s cubic-bezier(.22,1,.36,1) both`; c.style.animationDelay = `calc(var(--i) * 60ms)`; });
  wishStates(page); wishPageState(page);
}

/* ───── bolsa ───── */
const cartSections = () => {
  const ids = [];
  if ($('#bag')) ids.push('cart-drawer');
  const page = $('[data-cart-page]'); if (page) ids.push(page.dataset.section);
  return ids;
};
function updateCounts(n, bump) {
  if (n == null) return;
  $$('[data-bag-count]').forEach(e => { e.textContent = `(${n})`; if (bump) { e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); } });
  const bn = $('#bagN'); if (bn) bn.textContent = n ? n : '';
}
function applySections(sections, newKey) {
  if (!sections) return null;
  let count = null;
  if (sections['cart-drawer']) {
    const d = parseHTML(sections['cart-drawer']);
    ['#bagBody', '#bagFoot', '#bagN'].forEach(s => { const a = $(s), b = $(s, d); if (a && b) a.innerHTML = b.innerHTML; });
    const nb = $('#bagBody', d); if (nb) count = +nb.dataset.count;
    if (newKey) { const li = $(`#bagBody .line[data-key="${CSS.escape(newKey)}"]`); if (li) li.classList.add('is-new'); }
    $('#bagBody') && $('#bagBody').classList.remove('is-busy'); $('#bagFoot') && $('#bagFoot').classList.remove('is-busy');
  }
  const page = $('[data-cart-page]');
  if (page && sections[page.dataset.section]) {
    const d = parseHTML(sections[page.dataset.section]);
    const a = $('[data-r="cart"]', page), b = $('[data-r="cart"]', d);
    if (a && b) { a.innerHTML = b.innerHTML; splitAll(a); $$('[data-reveal]', a).forEach(x => x.classList.add('in')); }
  }
  return count;
}
async function refreshCart() {
  const ids = cartSections();
  try {
    if (ids.length) {
      const r = await fetch(`${location.pathname}?sections=${ids.join(',')}`);
      const j = await r.json();
      const n = applySections(j);
      if (n != null) { updateCounts(n); return; }
    }
    const c = await (await fetch(`${R.root.replace(/\/$/, '')}/cart.js`)).json();
    updateCounts(c.item_count);
  } catch (e) {}
}
async function addToCart(id, qty, srcEl, label) {
  const ids = cartSections();
  const body = { items: [{ id: Number(id), quantity: qty || 1 }] };
  if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
  try {
    const res = await postJSON(R.cartAdd + '.js', body);
    const item = res.items ? res.items[0] : res;
    let n = applySections(res.sections, item && item.key);
    if (n == null) { try { const c = await (await fetch(`${R.root.replace(/\/$/, '')}/cart.js`)).json(); n = c.item_count; } catch (e) {} }
    if (srcEl && !RM) fly(srcEl).then(() => updateCounts(n, true)); else updateCounts(n, true);
    document.dispatchEvent(new CustomEvent('cart:added', { detail: { item } }));
    if (SC.afterAdd === 'drawer' && $('#bag')) { setTimeout(() => openOv('bag'), RM ? 0 : 500); }
    else toast(`<b>${esc(T.added)}</b>${esc(label || (item && item.title) || '')}`, { action: viewBag(), ms: 5200 });
    return true;
  } catch (err) {
    toast(`<b>${esc(T.error || 'Error')}</b>${esc(err.message)}`, { ms: 5200 });
    return false;
  }
}
function fly(src) {
  return new Promise(res => {
    const img = src.querySelector('img'); const r = src.getBoundingClientRect();
    const bagBtn = $('#bagBtn');
    if (!img || !bagBtn || !r.width || r.bottom < 0 || r.top > innerHeight) { res(); return; }
    const hidden = topEl && topEl.classList.contains('is-hidden');
    if (topEl) topEl.classList.remove('is-hidden');
    const t = bagBtn.getBoundingClientRect();
    const ty = hidden && topEl ? t.top + topEl.offsetHeight : t.top;
    const el = document.createElement('div'); el.className = 'fly';
    el.style.cssText = `left:${r.left}px;top:${r.top}px;width:${r.width}px;height:${r.height}px`;
    const im = new Image(); im.src = img.currentSrc || img.src; im.alt = ''; el.appendChild(im);
    document.body.appendChild(el);
    const dx = t.left + t.width / 2 - (r.left + r.width / 2), dy = ty + t.height / 2 - (r.top + r.height / 2);
    const s = 26 / r.width;
    el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px, ${dy * 0.5 - 60}px) scale(${Math.max(s * 4, 0.3)})`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(${s})`, opacity: 0 }
    ], { duration: 1050, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' }).finished.then(() => { el.remove(); res(); });
  });
}
async function changeLine(li, qty) {
  const ids = cartSections();
  const key = li.dataset.key;
  li.classList.add('is-busy');
  const run = async () => {
    try {
      const res = await postJSON(R.cartChange + '.js', { id: key, quantity: qty, sections: ids.join(','), sections_url: location.pathname });
      const n = applySections(res.sections);
      updateCounts(n != null ? n : res.item_count, true);
      const line = res.items && res.items.find(x => x.key === key);
      if (qty > 0 && line && line.quantity < qty) toast(`<b>${esc(T.error)}</b>${esc(T.maxStock || '')}`);
    } catch (err) {
      li.classList.remove('is-busy');
      toast(`<b>${esc(T.error || 'Error')}</b>${esc(err.message)}`);
    }
  };
  if (qty === 0 && !RM) {
    await li.animate([{ height: li.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px' }], { duration: 600, easing: 'cubic-bezier(.7,0,.2,1)', fill: 'forwards' }).finished;
  }
  await run();
}
function discountApplied(cart, code) {
  const c = code.toLowerCase();
  if (Array.isArray(cart.discount_codes)) {
    const f = cart.discount_codes.find(d => String(d.code).toLowerCase() === c);
    if (f) return f.applicable !== false;
  }
  if ((cart.cart_level_discount_applications || []).some(d => String(d.title).toLowerCase() === c)) return true;
  return (cart.items || []).some(it => (it.line_level_discount_allocations || []).some(a => a.discount_application && String(a.discount_application.title).toLowerCase() === c));
}
async function applyCode(code, msgEl) {
  const ids = cartSections();
  const inPage = !!(msgEl && msgEl.closest('[data-cart-page]'));
  const findMsg = () => (msgEl && document.contains(msgEl)) ? msgEl : $(inPage ? '[data-cart-page] [data-cmsg]' : '#bagFoot [data-cmsg]');
  const busy = [$('#bagBody'), $('#bagFoot')].filter(Boolean); busy.forEach(b => b.classList.add('is-busy'));
  try {
    const cart = await postJSON(R.cartUpdate + '.js', { discount: code, sections: ids.join(','), sections_url: location.pathname });
    if (!discountApplied(cart, code)) {
      const back = await postJSON(R.cartUpdate + '.js', { discount: '', sections: ids.join(','), sections_url: location.pathname });
      applySections(back.sections);
      const m = findMsg();
      if (m) { m.textContent = T.codeInvalid; m.classList.add('is-err'); const inp = m.previousElementSibling && $('input', m.previousElementSibling); if (inp) inp.value = code; }
      return false;
    }
    applySections(cart.sections);
    if (!cart.sections) await refreshCart();
    return true;
  } catch (err) {
    busy.forEach(b => b.classList.remove('is-busy'));
    const m = findMsg(); if (m) { m.textContent = err.message; m.classList.add('is-err'); }
    return false;
  } finally { busy.forEach(b => b.classList.remove('is-busy')); }
}
let noteT = null;
function initCart() {
  document.addEventListener('click', e => {
    const li = e.target.closest('.line[data-key]');
    if (li) {
      const q = e.target.closest('[data-qty]');
      if (q && !q.disabled) {
        const cur = +($('.qty span', li).textContent) || 1;
        changeLine(li, Math.max(0, cur + Number(q.dataset.qty)));
        return;
      }
      if (e.target.closest('[data-rm]')) { changeLine(li, 0); return; }
    }
    if (e.target.closest('[data-coupon-rm]')) {
      e.preventDefault();
      const ids = cartSections();
      postJSON(R.cartUpdate + '.js', { discount: '', sections: ids.join(','), sections_url: location.pathname }).then(r => applySections(r.sections)).catch(() => refreshCart());
    }
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-coupon]'); if (!f) return;
    e.preventDefault();
    const inp = $('input', f), msg = f.nextElementSibling;
    const v = inp.value.trim();
    if (!v) { if (msg) { msg.textContent = T.codeEmpty; msg.classList.add('is-err'); } return; }
    const ok = await applyCode(v, msg);
    if (ok) toast(`<b>${esc(T.codeApplied)}</b>${esc(v.toUpperCase())}`);
    else f.animate([{ transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'none' }], { duration: 300 });
  });
  document.addEventListener('input', e => {
    const n = e.target.closest('[data-cart-note]'); if (!n) return;
    clearTimeout(noteT);
    noteT = setTimeout(() => { postJSON(R.cartUpdate + '.js', { note: n.value }).catch(() => {}); }, 600);
  });
}

/* ───── buscador ───── */
let sAC = null, sT = null;
async function runSearch() {
  const inp = $('#q'), out = $('#sres'), sugg = $('#sugg'); if (!inp || !out) return;
  const q = inp.value.trim();
  if (sAC) sAC.abort();
  if (!q) { out.innerHTML = ''; if (sugg) sugg.hidden = false; return; }
  if (sugg) sugg.hidden = true;
  sAC = new AbortController();
  const url = `${R.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=8&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
  try {
    const html = await getText(url, sAC.signal);
    const d = parseHTML(html);
    const sec = $('#shopify-section-predictive-search', d) || d.body;
    out.innerHTML = sec.innerHTML.trim() || `<p class="sres-empty">${esc((T.searchNone || '').replace('{q}', q))}</p>`;
    wishStates(out);
  } catch (err) { if (err.name !== 'AbortError') out.innerHTML = ''; }
}
function initSearch() {
  document.addEventListener('input', e => { if (e.target.id === 'q') { clearTimeout(sT); sT = setTimeout(runSearch, 160); } });
}

/* ───── menú ───── */
function showPrev(i) { $$('#menuPrev .mp').forEach(m => m.classList.toggle('is-on', m.dataset.mp === String(i))); }
function initMenu() {
  document.addEventListener('click', e => {
    const b = e.target.closest('#menuMain button.mm');
    if (b) {
      const o = b.getAttribute('aria-expanded') !== 'true';
      $$('#menuMain button.mm').forEach(x => { if (x !== b) { x.setAttribute('aria-expanded', 'false'); x.nextElementSibling.classList.remove('is-open'); } });
      b.setAttribute('aria-expanded', String(o)); b.nextElementSibling.classList.toggle('is-open', o);
      $('#menuMain').classList.toggle('has-open', o);
      if (!o) b.blur();
      return;
    }
    if (e.target.closest('#menuBtn')) { isOpen('menu') ? closeOv('menu') : openOv('menu'); }
  });
  const prevH = e => { const t = e.target.closest && e.target.closest('#menu [data-prev]'); if (t) showPrev(t.dataset.prev); };
  document.addEventListener('pointerover', prevH);
  document.addEventListener('focusin', prevH);
}

/* ───── tarjetas: puntos de color y añadir rápido ───── */
function cardData(card) {
  if (card._d !== undefined) return card._d;
  const s = $('script[data-card-json]', card);
  try { card._d = s ? JSON.parse(s.textContent) : null; } catch (e) { card._d = null; }
  return card._d;
}
function cardColor(card, color, dot) {
  const d = cardData(card); if (!d || card.dataset.c === color) return;
  card.dataset.c = color;
  $$('.dot', card).forEach(x => x.classList.toggle('is-on', x === dot));
  const imgs = d.img && d.img[color];
  const a = $('.im-a', card), b = $('.im-b', card);
  const first = d.v.find(x => x[d.c] === d.v[0][d.c]);
  const u = d.u + (first && first[d.c] === color ? '' : (d.u.indexOf('?') > -1 ? '&' : '?') + 'color=' + encodeURIComponent(color));
  $$('.card-link, .card-name', card).forEach(l => { l.href = u; });
  if (imgs && imgs[0] && a) {
    a.classList.add('is-swap');
    const swap = () => {
      const ia = $('img', a); if (ia) { ia.removeAttribute('srcset'); ia.src = imgs[0]; }
      if (b) { const ib = $('img', b); if (ib && imgs[1]) { ib.removeAttribute('srcset'); ib.src = imgs[1]; b.hidden = false; } else if (b) b.hidden = !imgs[1]; }
      void a.offsetWidth; a.classList.remove('is-swap');
    };
    setTimeout(swap, RM ? 0 : 380);
  }
  const q = $('.q-s', card);
  if (q && d.s) {
    const sizes = [];
    d.v.forEach(x => { if (x[d.c] === color && !sizes.some(s => s[0] === x[d.s])) sizes.push([x[d.s], x]); });
    q.innerHTML = sizes.map(([s, x]) => `<button type="button" data-qa="${x[0]}"${x[4] ? '' : ` disabled aria-label="${esc(s)} · ${esc(T.soldOut)}"`}>${esc(s)}</button>`).join('');
  }
}

/* ───── colección y búsqueda: filtros, orden, densidad, cargar más ───── */
let rAC = null;
function resultsBox() { return $('[data-results]'); }
function sectionURL(url, box) { return withParam(url, 'section_id', box.dataset.section); }
function setCols(grid) {
  if (!grid) return;
  const base = +grid.dataset.cols || 3;
  const c = store.get('sc_cols', null);
  const n = innerWidth > 640 ? (c && $('.dens', resultsBox() || document) ? c : base) : 2;
  grid.style.setProperty('--cols', n);
  $$('[data-dens]').forEach(x => x.classList.toggle('is-on', +x.dataset.dens === (innerWidth > 640 ? n : 2)));
}
async function loadResults(url, o = {}) {
  const box = resultsBox(); if (!box) { location.href = url; return; }
  if (rAC) rAC.abort(); rAC = new AbortController();
  const clean = new URL(url, location.href); clean.searchParams.delete('section_id');
  const grid = $('[data-r="grid"]', box);
  let html;
  try {
    if (grid && !RM && !o.silent) grid.classList.add('is-leave');
    const [h] = await Promise.all([getText(sectionURL(clean.pathname + clean.search, box), rAC.signal), sleep(RM || o.silent ? 0 : 320)]);
    html = h;
  } catch (err) { if (err.name !== 'AbortError') location.href = clean.href; return; }
  const d = parseHTML(html);
  $$('[data-r]', box).forEach(el => {
    const k = el.dataset.r; const nw = $(`[data-r="${k}"]`, d);
    if (!nw) return;
    if (k === 'facets' && o.keepFacets) {
      const act = document.activeElement && document.activeElement.id;
      el.innerHTML = nw.innerHTML;
      if (act) { const a = document.getElementById(act); if (a) try { a.focus({ preventScroll: true }); } catch (e) {} }
      return;
    }
    if (k === 'empty') { el.hidden = nw.hidden; el.innerHTML = nw.innerHTML; return; }
    el.innerHTML = nw.innerHTML;
  });
  if (grid) { grid.classList.remove('is-leave'); setCols(grid); wishStates(grid); }
  if (!o.noHistory) history[o.replace ? 'replaceState' : 'pushState']({ facets: true }, '', clean.pathname + clean.search);
  if (o.scrollTop) { const tb = $('#toolbar'); if (tb && tb.getBoundingClientRect().top < 0) scrollToEl(box.querySelector('.shop-grid'), -160); }
}
function facetsURL(form) {
  const fd = new FormData(form); const p = new URLSearchParams();
  for (const [k, v] of fd.entries()) if (String(v).trim() !== '') p.append(k, v);
  return location.pathname + '?' + p.toString();
}
function initResults() {
  document.addEventListener('change', e => {
    const f = e.target.closest('form[data-facets]'); if (!f) return;
    const lab = e.target.closest('label'); if (lab && e.target.type === 'checkbox') lab.classList.toggle('is-on', e.target.checked);
    loadResults(facetsURL(f), { keepFacets: true });
  });
  document.addEventListener('submit', e => { const f = e.target.closest('form[data-facets]'); if (f) { e.preventDefault(); loadResults(facetsURL(f), { keepFacets: true }); } });
  document.addEventListener('click', e => {
    const fl = e.target.closest('[data-facet-link]');
    if (fl && resultsBox()) { e.preventDefault(); closeOv('filters'); loadResults(fl.href, { scrollTop: true }); return; }
    const sb = e.target.closest('[data-sort-btn]');
    if (sb) { const s = sb.closest('[data-sort-box]'); const o = !s.classList.contains('is-open'); s.classList.toggle('is-open', o); sb.setAttribute('aria-expanded', String(o)); return; }
    const so = e.target.closest('[data-sort]');
    if (so) {
      const box = so.closest('[data-sort-box]'); box.classList.remove('is-open');
      const form = $('form[data-facets]');
      let url;
      if (form) { const si = $('[data-sort-input]', form); if (si) si.value = so.dataset.sort; url = facetsURL(form); }
      else url = withParam(location.href, 'sort_by', so.dataset.sort);
      loadResults(url, { scrollTop: true }); return;
    }
    const dn = e.target.closest('[data-dens]');
    if (dn) { store.set('sc_cols', +dn.dataset.dens); const g = $('[data-r="grid"]'); if (g) { g.classList.add('is-leave'); setTimeout(() => { setCols(g); g.classList.remove('is-leave'); }, RM ? 0 : 280); } return; }
    const more = e.target.closest('[data-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }
    if (!e.target.closest('[data-sort-box]')) $$('[data-sort-box].is-open').forEach(s => { s.classList.remove('is-open'); const b = $('[data-sort-btn]', s); if (b) b.setAttribute('aria-expanded', 'false'); });
  });
  addEventListener('popstate', e => { if (resultsBox() && e.state && e.state.facets) loadResults(location.href, { noHistory: true, silent: true }); });
  addEventListener('resize', () => { const g = $('[data-r="grid"]'); if (g) setCols(g); });
}
async function loadMore(btn) {
  const box = resultsBox(); if (!box) { location.href = btn.href; return; }
  const wrap = btn.closest('[data-r="more"]'); wrap.classList.add('is-busy');
  try {
    const html = await getText(sectionURL(btn.getAttribute('href'), box));
    const d = parseHTML(html);
    const grid = $('[data-r="grid"]', box), ng = $('[data-r="grid"]', d);
    const start = grid.children.length;
    [...ng.children].forEach((c, i) => { c.style.setProperty('--i', i % 12); grid.appendChild(c); });
    $$('.card', grid).slice(start).forEach(c => wishStates(c));
    const nm = $('[data-r="more"]', d); wrap.innerHTML = nm ? nm.innerHTML : '';
    const u = new URL(btn.href, location.href); u.searchParams.delete('section_id');
    history.replaceState({ facets: true }, '', u.pathname + u.search);
  } catch (e) { location.href = btn.href; }
  wrap.classList.remove('is-busy');
}

/* ───── guía de tallas ───── */
function fillGuide() {
  const body = $('#sgBody'); if (!body) return;
  const tpl = $('[data-sg]');
  if (tpl) body.innerHTML = tpl.innerHTML;
}

/* ───── visor de fotos ───── */
const LB = { i: 0, zoom: false, list: [] };
function openLB(list, i) { LB.list = list; LB.i = i; drawLB(0); openOv('lightbox'); }
function drawLB(dir) {
  const st = $('#lbStage'); if (!st) return; lbZoom(false);
  st.innerHTML = `<div class="lb-img"><img src="${esc(LB.list[LB.i])}" alt="" draggable="false"></div>`;
  if (dir && !RM) st.firstElementChild.animate([{ opacity: 0, transform: `translateX(${dir * 50}px)` }, { opacity: 1, transform: 'none' }], { duration: 800, easing: 'cubic-bezier(.22,1,.36,1)' });
  $('#lbCount').textContent = `${LB.i + 1} / ${LB.list.length}`;
  const multi = LB.list.length > 1; $('#lbPrev').hidden = !multi; $('#lbNext').hidden = !multi;
}
function lbZoom(on, e) {
  LB.zoom = on; const st = $('#lbStage'); if (!st) return; const im = $('.lb-img', st);
  st.classList.toggle('is-zoom', on);
  if (!im) return;
  if (on && e) { const r = st.getBoundingClientRect(); im.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; }
  im.style.transform = on ? 'scale(2.2)' : '';
}
function initLB() {
  const st = $('#lbStage'); if (!st) return;
  st.addEventListener('click', e => lbZoom(!LB.zoom, e));
  st.addEventListener('pointermove', e => { if (!LB.zoom) return; const r = st.getBoundingClientRect(); const im = $('.lb-img', st); if (im) im.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
  $('#lbPrev').addEventListener('click', () => { LB.i = (LB.i + LB.list.length - 1) % LB.list.length; drawLB(-1); });
  $('#lbNext').addEventListener('click', () => { LB.i = (LB.i + 1) % LB.list.length; drawLB(1); });
}

/* ───── ficha de producto ───── */
function initPDP(el) {
  if (!el || el._b) return; el._b = true;
  let D; try { D = JSON.parse($('[data-pdp-json]', el).textContent); } catch (e) { return; }
  const cp = D.colorPos || 0;
  const gal = $('[data-gal]', el), dots = $('[data-dots]', el);
  const form = $('form[data-type="add-to-cart-form"]', el);
  const addBtn = $('[data-add]', el), vid = $('[data-vid]', el), stockEl = $('[data-stock]', el);
  const notifyBox = $('[data-notify]', el);
  const opts = $$('.opt[data-opt]', el);
  const LOW = +SC.lowStock || 0;
  const sel = [null, null, null];
  opts.forEach(o => { const i = +o.dataset.opt - 1; const on = $('.is-on[data-v]', o); sel[i] = on ? on.dataset.v : null; });
  const nOpts = D.variants.length ? D.variants[0].o.filter(x => x !== null).length : 0;
  for (let i = 0; i < nOpts; i++) if (sel[i] == null && !opts.some(o => +o.dataset.opt - 1 === i)) sel[i] = D.variants[0].o[i];
  if (cp) {
    const qc = new URLSearchParams(location.search).get('color');
    const co = opts.find(o => o.dataset.kind === 'color');
    const sw = qc && co ? $$('[data-v]', co).find(b => b.dataset.v.toLowerCase() === qc.toLowerCase()) : null;
    if (sw) {
      sel[cp - 1] = sw.dataset.v;
      $$('[data-v]', co).forEach(x => { const on = x === sw; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', String(on)); });
      const nm = $('[data-opt-name]', co); if (nm) nm.textContent = sw.dataset.v;
    }
  }
  const findV = () => D.variants.find(v => v.o.every((x, i) => x === null || x === sel[i]));
  const sizeOpts = opts.filter(o => o.dataset.kind === 'size');
  const filterOn = el.dataset.cfilter === 'true';
  const colorNames = cp ? [...new Set(D.variants.map(v => String(v.o[cp - 1]).toLowerCase()))] : [];
  const figs = gal ? $$('.g-im', gal) : [];
  const anyColorMedia = filterOn && figs.some(f => colorNames.includes(f.dataset.alt));

  const setBtn = (text, mode, disabled) => {
    if (!addBtn) return;
    const s = $('.t>span', addBtn); s.textContent = text; s.dataset.t = text;
    addBtn.dataset.mode = mode || 'add'; addBtn.disabled = !!disabled;
  };
  const sticky = $('[data-sticky]', el);
  function paintOptions() {
    sizeOpts.forEach(o => {
      const i = +o.dataset.opt - 1;
      $$('.size', o).forEach(b => {
        const val = b.dataset.v;
        const cands = D.variants.filter(v => v.o[i] === val && (!cp || cp - 1 === i || v.o[cp - 1] === sel[cp - 1]));
        const av = cands.filter(v => v.a);
        const out = !av.length;
        const low = !out && LOW > 0 && av.every(v => v.q != null && v.q > 0 && v.q <= LOW);
        b.classList.toggle('is-out', out);
        let lw = $('.lw', b);
        if (low && !lw) { lw = document.createElement('i'); lw.className = 'lw'; lw.setAttribute('aria-hidden', 'true'); b.appendChild(lw); }
        if (!low && lw) lw.remove();
      });
    });
    if (cp) {
      const o = opts.find(x => x.dataset.kind === 'color');
      if (o) $$('.swatch', o).forEach(b => b.classList.toggle('is-dim', !D.variants.some(v => v.o[cp - 1] === b.dataset.v && v.a)));
    }
  }
  function updStock(v) {
    if (!stockEl) return;
    stockEl.className = 'stock';
    const missing = sizeOpts.some(o => sel[+o.dataset.opt - 1] == null);
    if (missing) {
      const lowSizes = [];
      sizeOpts.forEach(o => { const i = +o.dataset.opt - 1; $$('.size', o).forEach(b => { if ($('.lw', b)) lowSizes.push(b.dataset.v); }); void i; });
      stockEl.innerHTML = lowSizes.length ? `<span class="pd"></span>${esc((T.lowSizes || '').replace('{sizes}', lowSizes.join(', ')))}` : '';
      setBtn(T.addToCart); if (notifyBox) notifyBox.hidden = true; return;
    }
    if (!v || !v.a) {
      stockEl.classList.add('is-err');
      stockEl.textContent = v ? (T.soldOutIn || '').replace('{variant}', v.o.filter(Boolean).join(' · ')) : T.unavailable;
      if (v && D.notify) setBtn(T.notifyMe, 'notify'); else setBtn(T.soldOut, 'out', true);
      return;
    }
    if (notifyBox) notifyBox.hidden = true;
    if (LOW > 0 && v.q != null && v.q > 0 && v.q <= LOW) stockEl.innerHTML = `<span class="pd"></span>${esc(v.q === 1 ? T.lowOne : (T.lowMany || '').replace('{n}', v.q))}`;
    else { stockEl.classList.add('is-ok'); stockEl.innerHTML = `<span class="pd"></span>${esc(T.available)}`; }
    setBtn(T.addToCart);
  }
  function updPrice(v) {
    const pp = $('[data-pp]', el); const vv = v || findV() || D.variants[0];
    if (pp && vv) pp.innerHTML = (vv.c > vv.p ? `<s class="pr-was">${esc(money(vv.c))}</s> ` : '') + `<span class="pr">${esc(money(vv.p))}</span>`;
    const sp = $('[data-sticky-price]', el); if (sp && vv) sp.textContent = money(vv.p);
  }
  function filterGallery(color, animate) {
    if (!gal || !figs.length) return;
    const c = String(color || '').toLowerCase();
    const apply = () => {
      if (anyColorMedia) figs.forEach(f => { const a = f.dataset.alt; f.classList.toggle('is-hidden', colorNames.includes(a) && a !== c); });
      else if (cp) {
        const v = D.variants.find(x => x.o[cp - 1] === color && x.m);
        if (v) { const f = figs.find(x => x.dataset.media === String(v.m)); if (f && gal.firstElementChild !== f) gal.insertBefore(f, gal.firstElementChild); }
      }
      const vis = figs.filter(f => !f.classList.contains('is-hidden'));
      vis.forEach((f, i) => { f.className = f.className.replace(/\bg-\d+\b/, 'g-' + i); });
      if (dots) dots.innerHTML = vis.map((f, i) => `<i class="${i ? '' : 'is-on'}"></i>`).join('');
      gal.scrollLeft = 0;
    };
    if (!animate || RM) { apply(); return; }
    gal.classList.add('is-swap');
    setTimeout(() => { apply(); void gal.offsetWidth; gal.classList.remove('is-swap'); }, 520);
  }
  function update(colorChanged, initial) {
    const v = findV();
    paintOptions();
    if (vid && v) vid.value = v.id;
    updPrice(v); updStock(v);
    if (!initial && v && !sizeOpts.some(o => sel[+o.dataset.opt - 1] == null)) {
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }
    if (colorChanged) {
      filterGallery(sel[cp - 1], true);
      const sv = D.variants.find(x => x.o[cp - 1] === sel[cp - 1] && x.img);
      const si = sticky && $('[data-sticky-img] img', sticky);
      if (si && sv) { si.removeAttribute('srcset'); si.src = sv.img; }
    }
  }
  opts.forEach(o => {
    o.addEventListener('click', e => {
      const b = e.target.closest('[data-v]'); if (!b) return;
      const i = +o.dataset.opt - 1;
      if (sel[i] === b.dataset.v && o.dataset.kind === 'color') return;
      sel[i] = b.dataset.v;
      $$('[data-v]', o).forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', String(on)); });
      const nm = $('[data-opt-name]', o); if (nm) nm.textContent = b.dataset.v;
      update(o.dataset.kind === 'color');
    });
  });
  function showNotify() {
    if (!notifyBox) return;
    notifyBox.hidden = false;
    const v = findV();
    const txt = $('[data-notify-txt]', notifyBox), fld = $('[data-notify-field]', notifyBox);
    const label = v ? v.o.filter(Boolean).join(' · ') : '';
    if (txt) txt.textContent = (T.notifyText || '').replace('{variant}', label);
    if (fld) fld.value = `${D.title}${label ? ' · ' + label : ''} (${v ? v.id : ''})`;
    const inp = $('input[type="email"]', notifyBox); if (inp) inp.focus();
  }
  async function add(fromSticky) {
    const missing = sizeOpts.find(o => sel[+o.dataset.opt - 1] == null);
    if (missing) {
      const box = $('.sizes', missing);
      if (fromSticky) scrollToEl(missing, -200);
      box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake');
      if (stockEl) { stockEl.className = 'stock is-err'; stockEl.textContent = (T.chooseSize || '').replace('{option}', ($('.lbl', missing).firstChild.textContent || '').toLowerCase()); }
      return;
    }
    if (addBtn.dataset.mode === 'notify') { if (fromSticky) scrollToEl(addBtn, -200); showNotify(); return; }
    const v = findV(); if (!v || !v.a || addBtn.classList.contains('is-load')) return;
    addBtn.classList.add('is-load');
    await sleep(RM ? 0 : 650);
    let src = null;
    if (fromSticky) src = $('[data-sticky-img]', el);
    else if (gal) { const vis = $$('.g-im:not(.is-hidden)', gal); src = innerWidth > 900 ? vis[0] : vis[Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth))] || vis[0]; }
    const label = `${D.title}${v.o.filter(Boolean).length && D.variants.length > 1 ? ' · ' + v.o.filter(Boolean).join(' · ') : ''}`;
    const ok = await addToCart(v.id, 1, src, label);
    addBtn.classList.remove('is-load');
    if (ok) { addBtn.classList.add('is-done'); setTimeout(() => addBtn.classList.remove('is-done'), 2100); }
  }
  if (form) form.addEventListener('submit', e => { e.preventDefault(); add(false); });
  const sb = $('[data-sticky-btn]', el); if (sb) sb.addEventListener('click', () => add(true));
  if (gal) {
    if (gal.hasAttribute('data-cursor')) gal.addEventListener('click', e => {
      const f = e.target.closest('.g-im'); if (!f || !f.dataset.full) return;
      const vis = $$('.g-im:not(.is-hidden)', gal).filter(x => x.dataset.full);
      openLB(vis.map(x => x.dataset.full), Math.max(0, vis.indexOf(f)));
    });
    gal.addEventListener('scroll', () => { const i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)); if (dots) $$('i', dots).forEach((d, j) => d.classList.toggle('is-on', j === i)); }, { passive: true });
  }
  if (sticky && addBtn) {
    const sync = () => { if (!document.contains(el)) { SCROLLERS.delete(sync); return; } setCls(sticky, 'is-on', addBtn.getBoundingClientRect().bottom < 0); };
    SCROLLERS.add(sync); sync();
  } else if (sticky) sticky.remove();
  if ($('[data-notify-ok]', el)) setTimeout(() => toast(`<b>${esc(T.notifyOn)}</b>`), 600);
  filterGallery(cp ? sel[cp - 1] : null, false);
  update(false, true);
  if (cp && sticky) { const sv = D.variants.find(x => x.o[cp - 1] === sel[cp - 1] && x.img); const si = $('[data-sticky-img] img', sticky); if (si && sv) { si.removeAttribute('srcset'); si.src = sv.img; } }
}

/* ───── recomendaciones ───── */
async function initRecos(scope) {
  for (const box of $$('[data-recos]', scope)) {
    if (box._b) continue; box._b = true;
    if (box.children.length) { wishStates(box); continue; }
    try {
      const html = await getText(box.dataset.url);
      const d = parseHTML(html); const nb = $('[data-recos]', d);
      if (nb && nb.innerHTML.trim()) { box.innerHTML = nb.innerHTML; splitAll(box); wishStates(box); observe(box); }
      else box.remove();
    } catch (e) { box.remove(); }
  }
}

/* ───── ventana de bienvenida y códigos ───── */
function copyText(btn, text) {
  const cp = $('.cp', btn) || btn;
  const old = cp.textContent;
  const ok = () => { cp.textContent = T.copied || 'Copiado'; setTimeout(() => { cp.textContent = old; }, 1800); };
  try { navigator.clipboard.writeText(text).then(ok, ok); } catch (e) { ok(); }
}
function initNews() {
  const m = $('#news'); if (!m) return;
  const posted = /[?&]customer_posted=true/.test(location.search) || $('[data-posted]', m);
  if (posted && $('[data-posted]', m)) { setTimeout(() => openOv('news'), DESIGN ? 0 : 900); return; }
  if (DESIGN || m.dataset.enabled !== 'true') return;
  const days = +m.dataset.days || 0, last = store.get('sc_news_t', 0);
  if (days > 0 && last && Date.now() - last < days * 864e5) return;
  if (days === 0 && ss.get('sc_news')) return;
  setTimeout(() => {
    if (stack.length || $('[data-cart-page]') || location.pathname.indexOf('/checkouts') > -1) return;
    ss.set('sc_news', '1'); openOv('news');
  }, (+m.dataset.delay || 14) * 1000);
}

/* ───── fechas de entrega ───── */
function initEta(scope) {
  $$('[data-eta]', scope).forEach(el => {
    const add = n => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    try {
      const f = new Intl.DateTimeFormat(LANG, { weekday: 'long', day: 'numeric', month: 'long' });
      el.textContent = (T.etaRange || '{a} – {b}').replace('{a}', f.format(add(+el.dataset.min || 2))).replace('{b}', f.format(add(+el.dataset.max || 4)));
    } catch (e) {}
  });
}

/* ───── formularios ───── */
function validateForm(f) {
  let bad = null;
  $$('.fl', f).forEach(w => {
    const inp = $('input, textarea', w); if (!inp) return;
    const v = inp.value.trim();
    let good = true;
    if (inp.hasAttribute('data-email')) good = EMAIL.test(v);
    else if (inp.dataset.min) good = v.length >= +inp.dataset.min;
    w.classList.remove('is-err');
    if (!good) { void w.offsetWidth; w.classList.add('is-err'); if (!bad) bad = inp; }
  });
  return bad;
}
function initForms() {
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('[data-validate]')) { const bad = validateForm(f); if (bad) { e.preventDefault(); bad.focus(); } return; }
    const em = f.querySelector('input[name="contact[email]"]');
    if (em && (f.id === 'newsF' || f.id === 'footNews' || f.classList.contains('notify') || f.classList.contains('news-form') || f.classList.contains('foot-form'))) {
      if (!EMAIL.test(em.value.trim())) {
        e.preventDefault();
        const err = f.querySelector('.err'); if (err) err.textContent = T.emailInvalid || '';
        f.animate([{ transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'none' }], { duration: 320 });
      }
    }
  });
  document.addEventListener('input', e => { const w = e.target.closest('.fl.is-err'); if (w) w.classList.remove('is-err'); });
  document.addEventListener('change', e => { const s = e.target.closest('[data-autosubmit]'); if (s && s.form) s.form.submit(); });
  // acceso: recuperar contraseña
  const lb = $('[data-login-box]');
  if (lb && (location.hash === '#recover' || $('[data-recover-ok]', lb) || $('[data-recover] .form-err', lb))) { $('[data-login]', lb).hidden = true; $('[data-recover]', lb).hidden = false; }
}

/* ───── clics globales ───── */
function initClicks() {
  document.addEventListener('click', e => {
    const t = e.target; if (!(t instanceof Element)) return;
    let el;
    if ((el = t.closest('.acc-b'))) {
      const pnl = document.getElementById(el.getAttribute('aria-controls')); const o = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', String(o)); if (pnl) pnl.classList.toggle('is-open', o); return;
    }
    if ((el = t.closest('[data-open]'))) {
      const id = el.dataset.open;
      if (id === 'bag' && SC.cartType === 'page') return;
      if (document.getElementById(id)) { e.preventDefault(); openOv(id, el.dataset.arg); }
      return;
    }
    if ((el = t.closest('[data-close]'))) { e.preventDefault(); const ov = el.closest('.ov'); if (ov) closeOv(ov.id); return; }
    if ((el = t.closest('[data-wish]'))) { e.preventDefault(); toggleWish(el.dataset.wish, el); return; }
    if ((el = t.closest('[data-dot]'))) { e.preventDefault(); cardColor(el.closest('.card'), el.dataset.dot, el); return; }
    if ((el = t.closest('[data-qa]'))) {
      e.preventDefault(); if (el.disabled) return;
      const c = el.closest('.card');
      const name = c ? $('.card-name', c).textContent : '';
      const size = el.closest('.q-s') ? el.textContent : '';
      const color = c && c.dataset.c ? c.dataset.c : '';
      addToCart(el.dataset.qa, 1, c ? $('.im-a', c) : null, [name, color, size].filter(Boolean).join(' · '));
      return;
    }
    if ((el = t.closest('[data-q]'))) { const q = $('#q'); if (q) { q.value = el.dataset.q; runSearch(); } return; }
    if ((el = t.closest('[data-copy]'))) { e.preventDefault(); copyText(el, el.dataset.copy); return; }
    if ((el = t.closest('[data-apply-code]'))) {
      e.preventDefault();
      const code = el.dataset.applyCode;
      applyCode(code, null).then(ok => {
        closeOv('news');
        toast(`<b>${esc(ok ? T.codeApplied : T.codeInvalid)}</b>${esc(code)}`, { action: ok ? viewBag() : null });
      });
      return;
    }
    if ((el = t.closest('[data-scroll]'))) { e.preventDefault(); scrollToEl(document.getElementById(el.dataset.scroll)); return; }
    if ((el = t.closest('[data-recover-toggle]'))) { e.preventDefault(); const lb = el.closest('[data-login-box]'); if (lb) { const r = $('[data-recover]', lb), l = $('[data-login]', lb); const show = r.hidden; r.hidden = !show; l.hidden = show; } return; }
    if ((el = t.closest('[data-addr-edit]'))) { e.preventDefault(); const f = document.getElementById('addr-' + el.dataset.addrEdit); if (f) f.hidden = !f.hidden; return; }
    if ((el = t.closest('a[href]'))) {
      const u = veilLink(el, e);
      if (u) {
        e.preventDefault();
        const logo = el.hasAttribute('data-veil-logo') || u.pathname === (R.root || '/');
        let label = el.dataset.veil;
        if (label == null) { const tx = (el.textContent || '').trim().replace(/\s+/g, ' '); label = tx.length < 42 ? tx : ''; }
        navigate(u, label, logo);
      }
    }
  });
  document.addEventListener('submit', e => { const f = e.target.closest('[data-addr-del]'); if (f && !confirm(T.confirmDelete || '¿Seguro?')) e.preventDefault(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { if ($('[data-sort-box].is-open')) { $$('[data-sort-box].is-open').forEach(s => s.classList.remove('is-open')); return; } if (stack.length) closeOv(); }
    if (isOpen('lightbox')) { if (e.key === 'ArrowRight') $('#lbNext').click(); if (e.key === 'ArrowLeft') $('#lbPrev').click(); }
  });
  // carga anticipada de la página al pasar por un enlace
  const pre = new Set();
  const prefetch = e => {
    const a = e.target.closest && e.target.closest('a[href]'); if (!a || DESIGN) return;
    let u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || pre.has(u.href) || u.pathname === location.pathname || /\/(checkouts?|cart|account)/.test(u.pathname)) return;
    pre.add(u.href);
    const l = document.createElement('link'); l.rel = 'prefetch'; l.href = u.href; document.head.appendChild(l);
  };
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  addEventListener('scroll', tick, { passive: true });
  addEventListener('resize', () => { HDR = 0; LSY = 0; measureHero(); tick(); });
}

/* ───── iniciar una zona (página o sección recargada en el editor) ───── */
function initScope(scope) {
  revealScope(scope);
  $$('[data-hero]', scope).forEach(bindHero);
  $$('[data-pdp]', scope).forEach(initPDP);
  initRecos(scope);
  initWishPage(scope);
  initEta(scope);
  wishStates(scope);
  const g = $('[data-r="grid"]', scope); if (g) setCols(g);
  parEls = $$('.par', app);
}

/* ───── editor de temas ───── */
function initEditor() {
  if (!DESIGN) return;
  document.addEventListener('shopify:section:load', e => {
    refreshHeader(); initAnn(); measureHero();
    initScope(e.target); observe(e.target);
  });
  document.addEventListener('shopify:section:select', e => { if ($('#news', e.target)) openOv('news'); });
  document.addEventListener('shopify:section:deselect', e => { if ($('#news', e.target)) closeOv('news'); });
  document.addEventListener('shopify:block:select', e => {
    const s = e.target.closest('.ann-msg'); if (s) { $$('.ann-msg').forEach(m => m.classList.toggle('is-on', m === s)); }
  });
}

/* ───── arranque ───── */
function boot() {
  refreshHeader();
  initLenis(); initRipple(); initCursor(); initAnn(); initParallax();
  initMenu(); initSearch(); initCart(); initResults(); initLB(); initForms(); initClicks(); initEditor();
  initScope(document);
  measureHero(); frame();
  const finish = () => { isReady = true; readyResolve(); observe(document); initNews(); };
  if ($('#intro')) runIntro().then(finish);
  else if (root.classList.contains('veil-pre')) { Veil.revealOnLoad(); setTimeout(finish, 380); }
  else finish();
  addEventListener('load', () => { HDR = 0; LSY = 0; measureHero(); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
